import {
  Mail,
  Phone,
  MapPin,
  Facebook,
  Instagram,
  Linkedin,
  X,
  Hash,
} from 'lucide-react'

import LogoMark from '../ui/LogoMark.jsx'

export default function SiteFooter() {
  const contact = {
    emails: ['contact@ritikmedicare.in', 'ritikmedicare@gmail.com'],
    phone: '+91 7996337555',
    location:
      'Kamakunj, Pali Hill No. 3, Near Water Tank 1-G, Tithal Road, Bhagadawada, Taluka - Valsad, Valsad, Gujarat, India - 396001',
  }

  return (
    <footer className="bg-sectionBg border-t border-slate-200">
      <div className="mx-auto max-w-7xl px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-3">
              <div className="shrink-0 overflow-hidden">
                <LogoMark />
              </div>
              {/* <div className="max-w-[320px]">
                <div className="font-bold text-slate-900">Ritik Medicare Pvt. Ltd.</div>
                <div className="text-sm text-slate-600">API Manufacturing & Pharmaceutical Solutions</div>
              </div> */}
            </div>
            <p className="mt-4 text-sm text-slate-600 leading-relaxed">
              Pharmaceutical-grade manufacturing focused on quality, documentation, and reliable scale-up.
            </p>
          </div>


          <div className="space-y-3">
            <div className="font-semibold text-slate-900">Contact</div>

            <div className="flex flex-wrap gap-3">
           
              <a
                href="https://www.facebook.com/share/1EwGRcHG3A/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white/70 text-slate-700 hover:text-brand-primary hover:border-brand-primary transition"
              >
                <Facebook size={16} />
              </a>
              <a
                href="https://www.instagram.com/ritikmedicare?igsh=Ym1iazg3NXpqejZ5"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white/70 text-slate-700 hover:text-brand-primary hover:border-brand-primary transition"
              >
                <Instagram size={16} />
              </a>
              <a
                href="https://www.linkedin.com/in/ritik-medicare-b956111b9/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white/70 text-slate-700 hover:text-brand-primary hover:border-brand-primary transition"
              >
                <Linkedin size={16} />
              </a>
              
            </div>

            {contact.emails.map((email) => (
              <a
                key={email}
                className="flex items-center gap-2 text-sm text-slate-600 hover:text-brand-primary"
                href={`mailto:${email}`}
              >
                <Mail size={16} />
                {email}
              </a>
            ))}
            <a
              className="flex items-center gap-2 text-sm text-slate-600 hover:text-brand-primary"
              href={`tel:${contact.phone}`}
            >
              <Phone size={16} />
              {contact.phone}
            </a>
            <div className="flex items-center gap-2 text-sm text-slate-600">
              <MapPin size={16} />
              {contact.location}
            </div>
          </div>


          <div className="space-y-3">
            <div className="font-semibold text-slate-900">Quick Links</div>
            <div className="grid grid-cols-2 gap-3 text-sm">
              <a className="text-slate-600 hover:text-brand-primary" href="/about">
                About
              </a>
              <a className="text-slate-600 hover:text-brand-primary" href="/services">
                Services
              </a>
              <a className="text-slate-600 hover:text-brand-primary" href="/products">
                Products
              </a>
              <a className="text-slate-600 hover:text-brand-primary" href="/contact">
                Contact
              </a>
            </div>
            <div className="pt-3 text-xs text-slate-500">
              © {new Date().getFullYear()} Ritik Medicare Pvt. Ltd. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

